export default __webpack_public_path__ + "static/media/SurfaceHub.44f6629a.svg";